import React, { Component } from "react";
import classNames from "classnames";
import { EcartType } from "../enums";
import { IyourPdfButtonComponentProps } from "../types/props";
import "./yourPdfButtonComponent.scss";

class YourPdfButtonComponent extends Component<IyourPdfButtonComponentProps> {
  render() {
    if (!this.props.trayOpen) {
      if(this.props.cartType === 'indexed'){
        return (
          <button className={classNames({
            "pdf-button" : true,
            "pdf-button--pdf" : this.props.pdfLink
          })} onClick={this.openTray}>
            Your PDF <span>({this.props.count})</span>
          </button>
        );
      }
      return (
        <button className={classNames({
          "pdf-button" : true,
          "pdf-button--pdf": this.props.pdfLink,
        })} onClick={this.openTray}>
          <i><span>{this.props.count}</span></i>Your PDF
        </button>
      );
    }
    return null;
  }
  openTray = () => {
    this.props.openTray();
  };
}

export default YourPdfButtonComponent;
